import axios from 'axios'

import _storage from '../services/StorageService'
import { ENGINE_METHOD_STORE } from 'constants';

const serverUri = process.env.VUE_APP_API; //'https://api.myselfie.com';

var tokenRefresh = 0;
function getConfig() {
    return {
        headers: getAuthHeader()
    };
}

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.log("response",response);
    
    
    return response;
}, function (error) {
    
    if(error.response && error.response.status === 401)
        document.location ="/#/login";
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
},);

function getUrl(url) {
    if (url.indexOf("http") === 0)
        return url;

    return serverUri + url;
}

function postApi(url, data) {
    return axios.post(getUrl(url), data, getConfig())
}

function putApi(url, data) {
    return axios.put(getUrl(url), data, getConfig());
}

function deleteApi(url, data) {
    return axios.delete(getUrl(url), getConfig());
}

function getApi(url, data) {
    
    axios.headers = getAuthHeader()
    return axios.get(getUrl(url), getConfig())
        .catch(error => {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (error.response.status === 401)
                    window.location = "/#/login";
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            console.log(error.config);
        });;
}


function getAuthHeader() {
    return {
        'Authorization': "Bearer " + _storage.getItem("mys_token")
    }
}



export default {
    getApi: getApi,
    postApi: postApi,
    putApi: putApi,
    deleteApi : deleteApi
}
